import script from "./PhotosPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotosPage.vue?vue&type=script&setup=true&lang=js"

import "./PhotosPage.vue?vue&type=style&index=0&id=05891db8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05891db8"]])

export default __exports__